export const DocumentUploadUtils = {
  // Maximum file size in bytes (10MB)
  maxFileSize: 10 * 1024 * 1024,
  // Allowed file extensions
  allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png'],

  validateFile: (file) => {
    const result = {
      isValid: false,
      errorMessage: null,
    };

    if (!file) {
      result.errorMessage = 'No se ha seleccionado ningún archivo';
      return result;
    }

    if (file.size > DocumentUploadUtils.maxFileSize) {
      result.errorMessage = `El archivo es demasiado grande. Tamaño máximo: ${DocumentUploadUtils.formatFileSize(
        DocumentUploadUtils.maxFileSize,
      )}`;
      return result;
    }

    // Check file extension
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    if (!fileExtension || !DocumentUploadUtils.allowedExtensions.includes(fileExtension)) {
      result.errorMessage = `Formato de archivo no válido. Formatos permitidos: ${DocumentUploadUtils.allowedExtensions.join(
        ', ',
      )}`;
      return result;
    }

    result.isValid = true;
    return result;
  },

  formatFileSize: (bytes) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
  },

  fileToBase64: (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
    });
  },

  getFileExtension: (fileName) => {
    return fileName.split('.').pop()?.toLowerCase() || '';
  },
};

export default DocumentUploadUtils;
